import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {FileSaverService} from 'ngx-filesaver';

@Injectable()
export class DocumentsService extends SecurityService {
  _FileSaverService: FileSaverService = inject(FileSaverService);
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  getDocuments(): Observable<any> {
    let serviceUrl = this.baseUrl + 'DocumentsService/getDocuments?';

    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  downloadFile(path: string, name: string): Observable<Blob> {
    var namex = name;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options = {
      headers: headers,
      responseType: 'blob',
    };

    return this.request(this.baseUrl + 'DocumentsService/download?' + 'path=' + path, options).pipe(
      map(function (res) {
        let blob = new Blob([res.blob()], {
          type: res.headers.get('content-type'),
        });
        this._FileSaverService.save(blob, namex);
        return blob;
      }),
      catchError(this.handleError),
    );
  }
}
